import axios from 'axios';
import { authHeader } from './utils';
import {
  GET_MESSAGE_MACRO,
  GET_MESSAGE_MACRO_SUCCESS,
  GET_MESSAGE_MACRO_FAILURE,
  GET_MESSAGE_MACROS,
  GET_MESSAGE_MACROS_SUCCESS,
  GET_MESSAGE_MACROS_FAILURE,
  SUBMIT_MESSAGE_MACRO,
  SUBMIT_MESSAGE_MACRO_SUCCESS,
  SUBMIT_MESSAGE_MACRO_FAILURE,
  UPDATE_MESSAGE_MACRO,
  UPDATE_MESSAGE_MACRO_SUCCESS,
  UPDATE_MESSAGE_MACRO_FAILURE,
  DELETE_MESSAGE_MACRO,
  DELETE_MESSAGE_MACRO_SUCCESS,
  DELETE_MESSAGE_MACRO_FAILURE,
} from './types';

export const getMessageMacro = (id) => async (dispatch) => {
  dispatch({ type: GET_MESSAGE_MACRO });
  try {
    const res = await axios.get(`/api/messages/macros/${id}`, {
      headers: authHeader(),
    });
    dispatch({ type: GET_MESSAGE_MACRO_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: GET_MESSAGE_MACRO_FAILURE, payload: error.message });
  }
};

export const fetchMessageMacros = (page, limit) => async (dispatch) => {
  dispatch({ type: GET_MESSAGE_MACROS });
  try {
    const res = await axios.get('/api/messages/macros', {
      headers: authHeader(),
      params: { page, limit },
    });
    console.log('fetchMessageMacros res', res);
    dispatch({ type: GET_MESSAGE_MACROS_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: GET_MESSAGE_MACROS_FAILURE, payload: error.message });
  }
};

export const submitMessageMacro =
  ({ messageMacro }) =>
  async (dispatch) => {
    dispatch({ type: SUBMIT_MESSAGE_MACRO });
    try {
      const res = await axios.post('/api/messages/macros', messageMacro, {
        headers: authHeader(),
      });
      dispatch({ type: SUBMIT_MESSAGE_MACRO_SUCCESS, payload: res.data });
    } catch (error) {
      dispatch({ type: SUBMIT_MESSAGE_MACRO_FAILURE, payload: error.message });
    }
  };

export const updateMessageMacro =
  ({ messageMacro, id }) =>
  async (dispatch) => {
    dispatch({ type: UPDATE_MESSAGE_MACRO });
    try {
      const res = await axios.put(`/api/messages/macros/${id}`, messageMacro, {
        headers: authHeader(),
      });
      dispatch({ type: UPDATE_MESSAGE_MACRO_SUCCESS, payload: res.data });
    } catch (error) {
      dispatch({ type: UPDATE_MESSAGE_MACRO_FAILURE, payload: error.message });
    }
  };

export const deleteMessageMacro =
  ({ id }) =>
  async (dispatch) => {
    dispatch({ type: DELETE_MESSAGE_MACRO });
    try {
      const res = await axios.delete(`/api/messages/macros/${id}`, {
        headers: authHeader(),
      });
      dispatch({ type: DELETE_MESSAGE_MACRO_SUCCESS, payload: res.data });
      // navigate('/messages/macros', { replace: true });
    } catch (error) {
      dispatch({ type: DELETE_MESSAGE_MACRO_FAILURE, payload: error.message });
    }
  };
